import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/work_report_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  date_eq: {
    column_type: 'date',
    model_name: 'WorkReport',
    column_name: 'date',
  },
}
export const formColumnsConfig = {
  'self': {
    'date': { required: true, disabledUpdate: false },
    'content': { required: true, disabledUpdate: false },
    'plan': { required: true, disabledUpdate: false },
    'inquiry_content': { required: false, disabledUpdate: false },
    'files': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('WorkReport', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('WorkReport', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
